// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"78588c08","239":"b4dd9b65","453":"adbb7151","455":"35e759a6"}[chunkId] + ".chunk.js";
};